<template>
  <div v-if="quote">
    <v-btn @click="print">
      <v-icon>print</v-icon>
    </v-btn>
    <div id="quotePrintPanel">
      <v-btn
        v-if="quote.quotetypeid == 3 && $keycloak.hasRealmRole('root')"
        @click="repairQuote"
        >Repair quote</v-btn
      >
      <Header
        :lastUpdated="lastUpdated"
        :quote="quote"
        @triggerUpdate="triggerUpdate"
      />
      <Referrer
        id="quoteReferrer"
        :quote="quote"
        :lastUpdated="lastUpdated"
        :selectedHeaderElement="selectedHeaderElement"
        @changeSelectedHeaderElement="changeSelectedHeaderElement"
      />
      <Cqs
        id="quoteCqs"
        :quote="quote"
        :lastUpdated="lastUpdated"
        :selectedHeaderElement="selectedHeaderElement"
        @changeSelectedHeaderElement="changeSelectedHeaderElement"
      />
      <Details
        id="quoteDetails"
        :quote="quote"
        :lastUpdated="lastUpdated"
        :selectedHeaderElement="selectedHeaderElement"
        @changeSelectedHeaderElement="changeSelectedHeaderElement"
      />
      <Email
        id="quoteEmails"
        :quote="quote"
        :lastUpdated="lastUpdated"
        :selectedHeaderElement="selectedHeaderElement"
        @changeSelectedHeaderElement="changeSelectedHeaderElement"
      />
      <Answer
        id="quoteAnswers"
        :quote="quote"
        :lastUpdated="lastUpdated"
        :selectedHeaderElement="selectedHeaderElement"
        @changeSelectedHeaderElement="changeSelectedHeaderElement"
      />
      <Links id="quoteLinks" :quote="quote" :lastUpdated="lastUpdated" />
      <Quotation
        id="quoteQuotation"
        :quote="quote"
        :lastUpdated="lastUpdated"
        :selectedHeaderElement="selectedHeaderElement"
        @changeSelectedHeaderElement="changeSelectedHeaderElement"
      />
    </div>
  </div>
</template>

<script>
import QUOTE from "@/graphql/sales/quote/Quote";
import Answer from "@/components/quote/Answer";
import Cqs from "@/components/quote/Cqs";
import Details from "@/components/quote/Details";
import Email from "@/components/quote/Email";
import Header from "@/components/quote/Header";
import Links from "@/components/quote/Links";
import Quotation from "@/components/quote/Quotation";
import Referrer from "@/components/quote/Referrer";
import nbmlaw from "@/api/nbmlaw";
import { printElement } from "@/util/helpers";
export default {
  name: "Quote",
  metaInfo() {
    const title = this.computedTitle;
    return {
      title,
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    quote: {
      query: QUOTE,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    Answer,
    Cqs,
    Details,
    Email,
    Header,
    Links,
    Quotation,
    Referrer
  },
  computed: {
    computedTitle() {
      return this.quote && this.quote.name
        ? `${this.$route.params.id} - ${this.quote.name}`
        : this.$route.params.id;
    }
  },
  data() {
    return {
      quote: null,
      lastUpdated: null,
      selectedHeaderElement: 0,
      toc: [
        {
          id: "quoteHeader",
          text: "Header",
          target: "#quoteHeader"
        },
        {
          id: "quoteReferrer",
          text: "Referrer",
          target: "#quoteReferrer"
        },
        {
          id: "quoteCqs",
          text: "Cqs",
          target: "#quoteCqs"
        },
        {
          id: "quoteDetails",
          text: "Details",
          target: "#quoteDetails"
        },
        {
          id: "quoteEmails",
          text: "Emails",
          target: "#quoteEmails"
        },
        {
          id: "quoteAnswers",
          text: "Answers",
          target: "#quoteAnswers"
        },
        {
          id: "quoteLinks",
          text: "Links",
          target: "#quoteLinks"
        },
        {
          id: "quoteQuotation",
          text: "Quotation",
          target: "#quoteQuotation"
        },
        {
          id: "quoteAdditional",
          text: "Additional",
          target: "#quoteAdditional"
        }
      ]
    };
  },
  methods: {
    async repairQuote() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/repair`,
        null
      );
      this.triggerUpdate();
    },
    triggerUpdate() {
      this.$apollo.queries.quote.refetch();
    },
    changeSelectedHeaderElement(selectedHeaderElement) {
      if (selectedHeaderElement == 0) {
        this.$apollo.queries.quote.refetch();
      }
      this.selectedHeaderElement = selectedHeaderElement;
    },
    print() {
      printElement("quotePrintPanel");
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.$store.commit("setTableOfContents", this.toc);
      }
    },
    quote: {
      handler() {
        this.lastUpdated = new Date();
      }
    }
  }
};
</script>

<style>
.quoteHeader0 {
  padding: 5px;
  background: #ffcccc;
  margin-bottom: 5px;
  border: 1px solid #bbbbbb;
}

.quoteHeader1 {
  padding: 5px;
  background: #ccffcc;
  margin-bottom: 5px;
  border: 1px solid #bbbbbb;
}

.quoteHeader2 {
  padding: 5px;
  background: #ffffcc;
  margin-bottom: 5px;
  border: 1px solid #bbbbbb;
}

.quoteHeader3 {
  padding: 5px;
  background: #efccff;
  margin-bottom: 5px;
  border: 1px solid #bbbbbb;
}

.quoteHeader4 {
  padding: 5px;
  background: #c9c9c9;
  margin-bottom: 5px;
  border: 1px solid #bbbbbb;
}

.quoteHeaderHeading {
  font-weight: bold;
  font-size: 12pt;
  margin-bottom: 5px;
}

.ipAddress {
  color: green;
}

.ipAddressBlack {
  color: red;
}
</style>
